export const MAO_ACCEPT = 'accepted'
export const MAX_OFFER_ATTEMPTS = 4
export const ABOVE_THRESHOLD_BELOW_RESERVE_STATUS =
  'above_threshold_below_reserve'
